import { HocuspocusProvider } from "@hocuspocus/provider";
import store from "@/state/store";
import { DocumentSessionManager, type SessionProviderFactory } from "./DocumentSessionManager";

const hocuspocusFactory: SessionProviderFactory = ({ url, roomName, ydoc, token, onStatus, onSynced, onAuthFailed, onStateless }) => {
    const provider = new HocuspocusProvider({
        url,
        name: roomName,
        document: ydoc,
        token: () => token(),
        onConnect: () => onStatus("connected"),
        onDisconnect: () => onStatus("offline"),
        onSynced: () => onSynced(),
        onAuthenticationFailed: ({ reason }) => onAuthFailed(reason),
        onStateless: ({ payload }) => onStateless(payload)
    });
    return provider;
};

const enabled = import.meta.env.VITE_COLLAB_ENABLED === "true";

export const documentSessionManager = new DocumentSessionManager({
    collabUrl: () => (enabled ? (import.meta.env.VITE_COLLAB_URL as string | undefined) : undefined),
    getToken: () => store.getState().clientToken.token ?? "",
    providerFactory: hocuspocusFactory
});

// F2: staging an edit while offline is correct CRDT behavior — the change
// lives in the local ydoc and syncs once the collab server is reachable
// again. But reloading the page before that reconnect silently discards the
// local ydoc after the user was told the edit "staged". Warn on unload
// whenever any live session still has changes only this tab has seen.
if (typeof window !== "undefined") {
    window.addEventListener("beforeunload", event => {
        if (!documentSessionManager.hasUnsyncedLocalChanges()) return;
        event.preventDefault();
        // Cross-browser convention: a non-empty returnValue is what triggers
        // the native "leave site?" prompt in browsers that still honor it.
        event.returnValue = "";
    });
}
